<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

const { ThemeProvider } = require("vue-styled-components");

@Component({
  components: { ThemeProvider },
})
export default class App extends Vue {}
</script>
<style lang="less">
#app {
  height: 100%;
  width: 100%;
  overflow-y: hidden;
}

#theme-provider {
  height: 100%;
}
</style>
